export const INITIATIVE_PEOPLE_TABS = {
  members: 'members',
  followers: 'followers',
  admins: 'admins',
  requests: 'requests',
} as const

export type InitiativePeopleTab = keyof typeof INITIATIVE_PEOPLE_TABS

export const INITIATIVE_PEOPLE_TAB_PARAM_KEY = 'tab'
